import "./Checkout.module.css";
import Header from "@/reusable_sections/Header";
import CheckoutContent from "./sections/CheckoutContent";
import Footer from "@/reusable_sections/Footer";
export default function CheckoutPage() {
  return <div>
      <Header />
      <CheckoutContent />
      <Footer />
    </div>;
}